import React from "react";
import { Trash2 } from "lucide-react";

/**
 * Confirmation modal for permanent user deletion.
 * Presentational only — caller owns the state and handlers.
 */
export default function DeleteUserModal({ user, loading, onCancel, onConfirm }) {
  if (!user) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/60"
      data-testid="delete-user-modal"
    >
      <div className="card-brutal !p-8 max-w-lg w-full bg-white">
        <div className="flex items-center gap-2 mb-3">
          <Trash2 size={18} className="text-red-700" />
          <h2 className="font-display font-black text-2xl">Delete user?</h2>
        </div>
        <p className="text-sm text-zinc-700 mb-4">
          You're about to permanently delete <strong className="font-mono">{user.email}</strong>. This cannot be undone.
        </p>
        <div className="border-2 border-black bg-red-50 p-4 mb-5 text-sm">
          <div className="font-bold mb-2">This will also delete:</div>
          <ul className="list-disc ml-5 space-y-1">
            <li>{user.lead_magnets_count ?? 0} lead magnet(s) + all landing pages</li>
            <li>{user.leads_count ?? 0} captured lead(s)</li>
            <li>Any autoresponder integrations, payment history, referral records</li>
            {user.stripe_subscription_id && (
              <li className="font-bold text-red-800">
                Active Stripe subscription will be canceled (billing stops immediately)
              </li>
            )}
          </ul>
        </div>
        <div className="flex gap-3 justify-end">
          <button onClick={onCancel} disabled={loading} className="btn-brutal-outline" data-testid="delete-user-cancel">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="btn-brutal !bg-red-700 !shadow-[4px_4px_0_#000]"
            data-testid="delete-user-confirm"
          >
            {loading ? "Deleting…" : "Yes, delete permanently"}
          </button>
        </div>
      </div>
    </div>
  );
}
